{
  "panel": {
    "title": "Assistente Xtreed",
    "subtitle": "Monta seus cursos por você",
    "close": "Recolher assistente",
    "newConversation": "Nova conversa",
    "conversations": "Conversas",
    "noConversations": "Nenhuma conversa ainda",
    "untitled": "Nova conversa",
    "deleteConversation": "Apagar conversa",
    "deleteConfirm": "Apagar esta conversa? Os cursos criados continuam na área de membros.",
    "loadOlder": "Carregar mensagens anteriores"
  },
  "empty": {
    "title": "Vamos montar seu curso?",
    "description": "Me conte sobre o curso e mande os vídeos ou links. Eu organizo módulos e aulas, você aprova e eu subo tudo na área de membros.",
    "suggestions": {
      "newCourse": "Montar um curso novo",
      "newCoursePrompt": "Quero montar um curso novo na minha área de membros.",
      "addModule": "Adicionar módulo a um curso",
      "addModulePrompt": "Quero adicionar um módulo a um curso que já existe.",
      "status": "Ver meus cursos",
      "statusPrompt": "Quais cursos eu tenho na área de membros?"
    },
    "context": {
      "title": "Neste curso",
      "review": "Revisar a estrutura deste curso",
      "reviewPrompt": "Revise a estrutura do curso que estou vendo e me diga o que falta para ficar pronto.",
      "describe": "Escrever descrições",
      "describePrompt": "Escreva descrições para o curso que estou vendo e para os módulos dele.",
      "publish": "Publicar este curso",
      "publishPrompt": "Quero publicar o curso que estou vendo. Confira se falta algo antes."
    }
  },
  "composer": {
    "label": "Mensagem para o assistente",
    "placeholder": "Descreva o curso ou cole links…",
    "placeholderRunning": "O assistente está respondendo…",
    "send": "Enviar",
    "stop": "Parar",
    "attach": "Anexar vídeos, imagens ou materiais",
    "dropHere": "Solte os arquivos para enviar",
    "removeAttachment": "Remover anexo"
  },
  "message": {
    "typing": "O assistente está escrevendo",
    "aborted": "Resposta interrompida.",
    "error": "Não consegui terminar esta resposta. Tente de novo."
  },
  "tools": {
    "get_member_area_overview": "Consultando seus cursos",
    "get_course_tree": "Lendo a estrutura do curso",
    "apply_course_plan": "Montando o curso",
    "create_course": "Criando o curso",
    "update_course": "Atualizando o curso",
    "create_module": "Criando módulo",
    "update_module": "Atualizando módulo",
    "reorder_modules": "Reordenando módulos",
    "create_lesson": "Criando aula",
    "update_lesson": "Atualizando aula",
    "reorder_lessons": "Reordenando aulas",
    "move_lesson": "Movendo aula",
    "set_lesson_video_embed": "Ligando vídeo por link",
    "attach_uploaded_video": "Ligando vídeo enviado",
    "set_course_image": "Definindo imagem do curso",
    "add_lesson_material": "Adicionando material",
    "get_upload_status": "Conferindo os envios",
    "set_course_visibility": "Ajustando visibilidade",
    "publish_course": "Publicando o curso",
    "delete_course": "Apagando o curso",
    "delete_module": "Apagando módulo",
    "delete_lesson": "Apagando aula",
    "unlink_module": "Tirando módulo do curso",
    "unlink_lesson": "Tirando aula do módulo",
    "get_member_area_link": "Buscando o link",
    "archive_course": "Arquivando o curso",
    "get_course_sales_status": "Conferindo a venda do curso",
    "set_module_image": "Definindo imagem do módulo",
    "list_course_sections": "Consultando a vitrine",
    "create_course_section": "Criando seção da vitrine",
    "add_course_to_section": "Colocando curso na vitrine",
    "remove_course_from_section": "Tirando curso da seção",
    "list_categories": "Consultando categorias",
    "create_category": "Criando categoria",
    "set_course_category": "Definindo categoria",
    "fallback": "Trabalhando"
  },
  "approval": {
    "title": "Preciso da sua confirmação",
    "approve": "Aprovar",
    "reject": "Não fazer",
    "adjust": "Pedir ajuste",
    "adjustPlaceholder": "O que você quer mudar?",
    "sendAdjust": "Enviar ajuste",
    "cancel": "Cancelar",
    "approved": "Aprovado",
    "rejected": "Recusado",
    "edited": "Aprovado com alterações",
    "expired": "Esta confirmação expirou",
    "actions": {
      "publish_course": "Publicar o curso na área de membros",
      "set_course_visibility": "Mudar a visibilidade de um curso publicado",
      "delete_course": "Apagar um curso",
      "delete_module": "Apagar um módulo",
      "delete_lesson": "Apagar uma aula",
      "unlink_module": "Tirar um módulo do curso",
      "unlink_lesson": "Tirar uma aula do módulo",
      "archive_course": "Tirar o curso do ar (arquivar)",
      "fallback": "Executar uma ação"
    },
    "visibilityTo": "Nova visibilidade: {{value}}"
  },
  "plan": {
    "title": "Proposta de estrutura",
    "existingCourse": "Novos módulos para um curso existente",
    "modules_one": "{{count}} módulo",
    "modules_zero": "{{count}} módulos",
    "modules_other": "{{count}} módulos",
    "lessons_one": "{{count}} aula",
    "lessons_zero": "{{count}} aulas",
    "lessons_other": "{{count}} aulas",
    "videoLink": "Vídeo por link",
    "videoUpload": "Vídeo enviado",
    "noVideo": "Sem vídeo",
    "free": "Grátis",
    "visibility": {
      "HIDDEN": "Oculto para quem não comprou",
      "LOCKED": "Visível com cadeado"
    },
    "editHint": "Você pode editar os títulos antes de aprovar.",
    "moduleLabel": "Módulo {{index}}"
  },
  "uploads": {
    "title": "Arquivos",
    "status": {
      "PENDING": "Aguardando",
      "UPLOADING": "Enviando",
      "UPLOADED": "Recebido",
      "PROCESSING": "Processando",
      "READY": "Pronto",
      "FAILED": "Falhou"
    },
    "retry": "Tentar de novo",
    "pickAgain": "Selecionar o arquivo de novo",
    "linked": "Ligado a uma aula"
  },
  "errors": {
    "runFailed": "Não foi possível falar com o assistente.",
    "createConversation": "Não foi possível abrir a conversa.",
    "deleteConversation": "Não foi possível apagar a conversa.",
    "upload": "Não foi possível enviar {{name}}.",
    "loadHistory": "Não foi possível carregar a conversa."
  }
}
